import React from "react";
// import { Container } from "react-bootstrap";
import Man from "../assets/man.png";

const Testimonials = () => {
  return (
    <div id="service" className="outer-page-content-container">
      <h2 className="Testimonial-title">Happy client Works</h2>
      <div className="arrowline">
        <div className="under-line"></div>{" "}
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="rgba(61,210,218,1)"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 11H8V13H12V16L16 12L12 8V11Z"></path>
          </svg>
        </span>
      </div>
      {/* slide show */}
      <div id="myCarousel" className="carousel slide" data-ride="carousel">
        {/* <!-- Carousel indicators --> */}
        <ol className="carousel-indicators">
          <li
            data-target="#myCarousel"
            data-slide-to="0"
            className="active"
          ></li>
          <li data-target="#myCarousel" data-slide-to="1"></li>
          <li data-target="#myCarousel" data-slide-to="2"></li>
          <li data-target="#myCarousel" data-slide-to="3"></li>
        </ol>
        {/* <!-- Wrapper for carousel items --> */}
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="img-box">
              <img src={Man} alt="" />
            </div>
            <div
              className="spacearound"
              style={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <div class="fa fa-quote-right fa-quote"></div>
              <p className="overview" style={{ paddingTop: "2em" }}>
                <b>Prasad Reddy</b>
              </p>
              <div class="fa fa-quote-left fa-quote"></div>
            </div>
            <p className="testimonial">
              VSN Granites and Exports has been my go-to supplier for
              high-quality granite on several international construction
              projects. Their stones are consistently beautiful, with a wide
              variety of colors and patterns to choose from. They were also very
              accommodating when it came to custom cutting and finishing the
              granite to our exact specifications. The entire export process was
              smooth, and the stones arrived on-site safely and securely. I
              wouldn't hesitate to recommend VSN to anyone looking for top-notch
              granite for their next project.
            </p>
            {/* <p className="overview"><b>Chandu</b></p> */}
            {/* Seo Analyst at <a href="#">OsCorp Tech.</a> */}
            <div className="star-rating">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star-o"></i>
                </li>
              </ul>
            </div>
          </div>
          <div className="carousel-item">
            <div className="img-box">
              <img src={Man} alt="" />
            </div>
            <div
              className="spacearound"
              style={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <div class="fa fa-quote-right fa-quote"></div>
              <p className="overview" style={{ paddingTop: "2em" }}>
                <b>Tara Bhai</b>
              </p>
              <div class="fa fa-quote-left fa-quote"></div>
            </div>
            <p className="testimonial">
              I've been working with VSN Granites and Exports for a few years
              now on smaller residential projects. Their granite selection is
              impressive, and their prices are very competitive. The quality of
              the stone is generally good, though I have occasionally
              encountered a minor imperfection. However, VSN's customer service
              is excellent, and they've always been quick to address any
              concerns I've had. Overall, I'm a satisfied customer and would
              recommend them to others, especially those looking for good
              value.👍.
            </p>
            {/* <p className="overview"><b>Ayyappa</b></p> */}
            {/* Media Analyst at <a href="#">SkyNet Inc.</a> */}
            <div className="star-rating">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>

                <li className="list-inline-item">
                  <i className="fa fa-star-half"></i>
                </li>
                {/* <li className="list-inline-item"><i className="fa fa-star-o"></i></li> */}
              </ul>
            </div>
          </div>
          <div className="carousel-item">
            <div className="img-box">
              <img src={Man} alt="" />
            </div>

            <div
              className="spacearound"
              style={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <div class="fa fa-quote-right fa-quote"></div>
              <p className="overview" style={{ paddingTop: "2em" }}>
                <b>Chandu</b>
              </p>
              <div class="fa fa-quote-left fa-quote"></div>
            </div>
            <p className="testimonial">
              VSN Granites and Exports strikes the perfect balance between value
              and customization. Their competitive pricing allows for beautiful
              granite countertops without breaking the bank. I especially
              appreciated their willingness to work with me to achieve the exact
              finish I desired. The granite I received is high quality, adding a
              touch of luxury to my recent home renovation. VSN's customer
              service is attentive and responsive, ensuring a smooth and
              satisfying experience.
            </p>
            {/* <p className="overview"><b>Krishna Mohan</b></p> */}
            {/* Media Analyst at <a href="#">SkyNet Inc.</a> */}
            <div className="star-rating">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>

                <li className="list-inline-item">
                  <i className="fa fa-star-half-o"></i>
                </li>
              </ul>
            </div>
          </div>
          <div className="carousel-item">
            <div className="img-box">
              <img src={Man} alt="" />
            </div>

            <div
              className="spacearound"
              style={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <div class="fa fa-quote-right fa-quote"></div>
              <p className="overview" style={{ paddingTop: "2em" }}>
                <b>Krishna Mohan</b>
              </p>
              <div class="fa fa-quote-left fa-quote"></div>
            </div>

            <p className="testimonial">
              While a minor imperfection was initially present in the first
              granite slab I chose from VSN Granites and Exports, they were
              incredibly transparent throughout the selection process. Their
              customer service team went above and beyond to ensure my
              satisfaction. They promptly provided a replacement slab, and upon
              careful inspection, it was perfect. VSN's dedication to customer
              satisfaction and their commitment to resolving any concerns
              quickly make them a reliable and trustworthy source for beautiful
              granite.
            </p>

            {/* Web Developer at <a href="#">Circle Ltd.</a> */}
            <div className="star-rating">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star"></i>
                </li>
                <li className="list-inline-item">
                  <i className="fa fa-star-half"></i>
                </li>

                {/* <li className="list-inline-item"><i className="fa fa-star-half-o"></i>
                                </li> */}
              </ul>
            </div>
          </div>
        </div>
        {/* <!-- Carousel controls --> */}
        <a
          className="carousel-control-prev"
          href="#myCarousel"
          data-slide="prev"
        >
          <i className="fa fa-angle-left"></i>
        </a>
        <a
          className="carousel-control-next"
          href="#myCarousel"
          data-slide="next"
        >
          <i className="fa fa-angle-right"></i>
        </a>
      </div>

      {/* --------------------- */}
    </div>
  );
};

export default Testimonials;
